import React from 'react';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { IForBankFormSubSections } from 'components/BusinessToolForm/Sections/forBankSections';

import { CompetitiveAnalysis } from './CompetitiveAnalysis';
import { ConsumerNeeds } from './ConsumerNeeds';
import { MarketAnalysisOverview } from './MarketAnalysisOverview';

const SUB_SECTIONS: IForBankFormSubSections = {
  [BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.MARKET_OVERVIEW]: MarketAnalysisOverview,
  [BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.CONSUMER_NEEDS]: ConsumerNeeds,
  [BUSINESS_TOOL_SUB_SECTIONS.MARKET_ANALYSIS.COMPETITIVE_ANALYSIS]: CompetitiveAnalysis,
};

export const MarketAnalysis: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
